<div class="maindiv">
  <simple-datagrid entityName="Mktpmeli" [parentRow]="parentRow" [condition]="condition" [componentedit]="criacaoProduto" ></simple-datagrid>
</div>
